import React from 'react';
import { Redirect, useRouteMatch } from 'react-router';
import { LearnerTrainingStatus } from '~/data';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from './state';

const selector = (s: TrainingState) =>
  select(s, 'items', 'highestUnlockedPosition', 'status');

/**
 * Goes to the default sequence for a training, either the last one accessed or the first one.
 */
export const DefaultSequence = () => {
  const { items, highestUnlockedPosition, status } = useTrainingStore(selector);
  const { url } = useRouteMatch();

  if (status === LearnerTrainingStatus.Completed) {
    return <Redirect to={`${url}/success`} />;
  }

  const item =
    items.find(i => i.position === highestUnlockedPosition) ||
    items.find(i => i.kind === 'sequence');

  if (item && item.kind === 'sequence') {
    return <Redirect to={`${url}/${item.id}`} />;
  }

  throw Error('could not find default sequence');
};
